import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetData } from "../../../hooks/useGetData";
import { useInsertData } from "../../../hooks/useInsertData";
import notify from "../../../components/notify";
import { useDeleteData } from "../../../hooks/useDeleteData";
import i18n from "../../../i18n/i18n";

// ✅ ADS (Book a Date)  =>  /book-a-date

export const getLastRate = createAsyncThunk(
  "/ratingSlice/getLastRate",
  async () => {
    try {
      const response = await useGetData(`/ratings/last-unrated`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);


export const rating = createAsyncThunk(
  "/ratingSlice/rating",
  async (data , { rejectWithValue }) => {
    try {
      const response = await useInsertData(`/ratings`, data);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify(i18n.t("network_error_message"), "error");
        return rejectWithValue(i18n.t("network_error_message"));
      } else {
        notify(error.response?.data?.message, "error");
        return rejectWithValue(error.response?.data?.message);
      }
    }
  },
);
export const skipRating = createAsyncThunk(
  "/ratingSlice/skipRating",
  async (data, { rejectWithValue }) => {
    try {
      const response = await useInsertData(`/ratings/skip`, data);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify(i18n.t("network_error_message"), "error");
        return rejectWithValue(i18n.t("network_error_message"));
      } else {
        notify(error.response?.data?.message, "error");
        return rejectWithValue(error.response?.data?.message);
      }
    }
  },
);

